import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  GAME_ACC,
  IPFS_URL,
  TEST_COLLECTION_NAME,
  CIVILISATION_ID,
} from '../../app/constants'
import { getAvatar } from '../../features/avatar/avatarSlice'
import { getProfile } from '../../features/userprofile/profileSlice'
import { CivilisationTitle } from '../containers/CivilisationTitle'

const AvatarPopup = ({
  isOpen,
  setIsOpen,
  avatars,
  avatarsTemplates,
  civilization,
  currentAvatar,
}) => {
  const user = useSelector((state) => state.user)
  const collection = useSelector((state) => state.galaktikaCollection)
  const dispatch = useDispatch()
  const [avatarCollection, setAvatarCollection] = useState()
  useEffect(() => {
    let avatarValuesArray

    if (collection.collections.Others)
      avatarValuesArray = Object.values(
        Object.fromEntries(
          Object.entries(collection.collections.Others).filter(([key]) =>
            key.includes('Avatar'),
          ),
        ),
      ).filter(
        (e) =>
          e.image !== currentAvatar.img &&
          !avatars.map((i) => i.data.img).includes(e.image),
      )

    setAvatarCollection(avatarValuesArray)
  }, [collection])

  const userHasAvatar = (template_id) => {
    return Boolean(
      avatars.find((avatar) => +avatar.template.template_id === template_id),
    )
  }

  const handleSaveAvatar = (id, img) => {
    const stake = async (id) => {
      const selectedAvatar = avatars.find(
        (avatar) => +avatar.template.template_id === id,
      )
      if (!selectedAvatar) {
        return console.log('DEBUGGING HANDLE SAVE', 'No avatar selected')
      }
      console.log('DEBUGGING HANDLE SAVE', selectedAvatar, 'SELECTED AVATAR')
      try {
        const result = await user.userAccount.signTransaction(
          {
            actions: [
              {
                account: 'atomicassets',
                name: 'transfer',
                authorization: [
                  {
                    actor: user.userAccount.accountName,
                    permission: user.userAccount.requestPermission,
                  },
                ],
                data: {
                  from: user.userAccount.accountName,
                  to: GAME_ACC,
                  asset_ids: [selectedAvatar.asset_id],
                  memo: 'stake avatar',
                },
              },
            ],
          },
          {
            blocksBehind: 3,
            expireSeconds: 1200,
          },
        )
        console.log('DEBUGGING HANDLE SAVE', result)
        // setAvatar(avatars[avatars.map(avatar => avatar.data.img).indexOf(img)]);
        // Need to get the avatar again from the blockchain and save to state
        // Ideally it would be on a saga not here or redux
        dispatch(getAvatar())
        dispatch(getProfile())
        setIsOpen(false)
      } catch (error) {
        console.log('DEBUGGING HANDLE SAVE', error)
      }
    }
    stake(id, img)
    dispatch(getAvatar)
  }

  const handleDeselect = () => {
    const unstake = async () => {
      try {
        const result = await user.userAccount.signTransaction(
          {
            actions: [
              {
                account: GAME_ACC,
                name: 'unstkavatar',
                authorization: [
                  {
                    actor: user.userAccount.accountName,
                    permission: user.userAccount.requestPermission,
                  },
                ],
                data: {
                  wallet: user.userAccount.accountName,
                  civilization_id: CIVILISATION_ID[civilization],
                },
              },
            ],
          },
          {
            blocksBehind: 3,
            expireSeconds: 1200,
          },
        )
        console.log(result)
        dispatch(getAvatar())
        dispatch(getProfile())
        setIsOpen(false)
      } catch (error) {
        console.log(error)
      }
    }
    unstake()
    setTimeout(() => dispatch(getAvatar), 2000)
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 z-30 bg-black bg-opacity-50 "
            onClick={() => setIsOpen(false)}
          />
        </Transition.Child>
        <div
          className="fixed inset-0 overflow-y-auto z-4"
          aria-hidden="true"
          onClick={() => setIsOpen(false)}
        />
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="z-0 opacity-0 scale-95"
            enterTo="z-40 opacity-100 scale-100"
            leave="ease-in duration-300"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="z-40 flex items-center justify-center">
              <div
                id="scrollbar"
                className={
                  'lg:min-w-[900px] ' +
                  '!w-fit !h-auto fixed z-50 bg-[#000000] border-[0.3px] border-solid border-[#AD945F] mix-blend-normal shadow-[0_4px_4px_rgba(0,0,0, 0.5)] rounded-2xl min-h-[75vh] max-w-[330px] max-h-full overflow-y-scroll overflow-x-hidden flex flex-col p-3 items-center gap-4'
                }
              >
                <button
                  onClick={() => setIsOpen(false)}
                  className="absolute top-[1%] right-[3%] text-4xl text-white outline-none"
                >
                  {'x'}
                </button>
                <Dialog.Title className="text-white ">
                  <div className="flex justify-start flex-col lg:flex-row items-center gap-4 w-[300px] lg:w-max">
                    <CivilisationTitle
                      civilisation={civilization}
                      vertical={false}
                    />
                    <span className="h-[50px] font-jura font-medium relative">
                      <div className="h-[54px] bg-[#5E3B13B2] absolute -z-10 -top-[15px] -left-[85px] w-[330px] block lg:hidden" />
                      Select your Avatar
                    </span>
                  </div>
                </Dialog.Title>
                <div className="flex flex-wrap gap-4">
                  {parseInt(currentAvatar.id) > -1 && (
                    <div className="flex flex-col justify-center items-center text-right text-[#F6DFAC]">
                      <img
                        src={
                          currentAvatar.img?.startsWith('Q')
                            ? `${IPFS_URL}${currentAvatar.img}`
                            : currentAvatar.img
                        }
                        alt={`Current Avatar`}
                        className=" w-[138px] lg:w-[175px] aspect-[3/5] object-cover"
                      />
                      <div className="mt-4">
                        <button
                          className="uppercase box-border w-[150px] h-[35px] border-solid border-[0.3px] border-[#00FFF0] rounded-[5px] font-jura font-medium text-[#00FFF0] hover:bg-[#00FFF0] hover:text-black/[85]"
                          onClick={(e) => {
                            handleDeselect(e)
                          }}
                        >
                          De - Select
                        </button>
                      </div>
                    </div>
                  )}
                  {avatarsTemplates
                    ? avatarsTemplates
                        .filter(
                          (avatarCfg) => avatarCfg.ipfs !== currentAvatar.img,
                        )
                        .map((avatar, i) => {
                          function handleSelect(e) {
                            const avatarImg = avatar.ipfs
                            const avatarId = avatar.template_id
                            e.preventDefault()
                            handleSaveAvatar(avatarId, avatarImg)
                          }

                          return (
                            <div
                              key={i}
                              className="flex flex-col justify-center items-center text-right text-[#F6DFAC]"
                            >
                              <img
                                src={`${IPFS_URL}${avatar.ipfs}`}
                                alt={`avatar ${i}`}
                                className={`w-[138px] lg:w-[175px] aspect-[3/5] object-cover ${
                                  !userHasAvatar(avatar.template_id) &&
                                  'filter grayscale'
                                }`}
                              />
                              <div className="mt-4">
                                {avatars.ipfs !==
                                  currentAvatar.img && (
                                  <button
                                    className="uppercase box-border w-[150px] h-[35px] border-solid border-[0.3px] border-[#00FFF0] rounded-[5px] font-jura font-medium text-[#00FFF0] hover:bg-[#00FFF0] hover:text-black/[85]"
                                    onClick={(e) => {
                                      !userHasAvatar(avatar.template_id)
                                        ? open(
                                            `https://wax-test.atomichub.io/market?order=asc&sort=price&state=1&symbol=WAX&template_id=${avatar.template_id}}`,
                                          )
                                        : handleSelect(e)
                                    }}
                                  >
                                    {!userHasAvatar(avatar.template_id)
                                      ? 'Buy'
                                      : 'Select'}
                                  </button>
                                )}
                                {avatar.ipfs ===
                                  currentAvatar.img && (
                                  <div className="uppercase box-border flex justify-center items-center w-[150px] h-[35px] border-solid border-[0.3px] border-[#00FFF0] rounded-[5px] font-jura font-medium text-[#00FFF0] bg-[#00FFF0] text-black/[85]">
                                    Selected
                                  </div>
                                )}
                              </div>
                            </div>
                          )
                        })
                    : null}
                  {avatarCollection
                    ? avatarCollection
                        .filter((e) => e.data?.series === civilization)
                        .map((avatar, i) => {
                          return (
                            <div
                              key={i}
                              className="flex flex-col justify-center items-center text-right text-[#F6DFAC] "
                            >
                              <img
                                src={
                                  avatar.image?.startsWith('Q')
                                    ? `${IPFS_URL}${avatar.image}`
                                    : avatar.image
                                }
                                alt={`avatar ${i}`}
                                className="grayscale w-[138px] lg:w-[165px] aspect-[3/4] object-cover"
                              />
                              <div className="mt-4 flex justify-evenly w-full">
                                {/* TODO: this links are from testnet change to the mainnet when in production */}
                                <a
                                  href={`https://wax-test.atomichub.io/explorer/template/${TEST_COLLECTION_NAME}/${avatar.template_id}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="flex justify-center items-center box-border w-[50px] h-[35px] border-solid border-[0.3px] border-[#00FFF0] rounded-[5px] font-jura font-medium text-[#00FFF0] hover:bg-[#00FFF0] hover:text-black/[85]"
                                >
                                  NB
                                </a>
                                <a
                                  href={`https://wax-test.atomichub.io/explorer/template/${TEST_COLLECTION_NAME}/${avatar.template_id}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  className=" flex justify-center items-center box-border w-[50px] h-[35px] border-solid border-[0.3px] border-[#00FFF0] rounded-[5px] font-jura font-medium text-[#00FFF0] hover:bg-[#00FFF0] hover:text-black/[85]"
                                >
                                  AH
                                </a>
                              </div>
                            </div>
                          )
                        })
                    : null}
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export default AvatarPopup
